import { fabric } from "fabric";

export const rotateCanvas = (canvas: fabric.Canvas, orientation: string) => {
  const canvasObjects = canvas.getObjects() as fabric.Object[];
  canvasObjects.forEach((obj) => {
    if (
      obj.angle !== undefined &&
      (obj.name === "svgShape" ||
        obj.name === "iText"   ||
        obj.name === "clipArt" ||
        obj.name === "image"   ||
        obj.name === "group")
    ) {
      if (orientation === "rotated") {
        obj.rotate(obj.angle + 90);

        const canvasCenterPoint = canvas.getCenter();
        const objectCenterPoint = obj.getCenterPoint();

        obj
          .set({
            left: canvasCenterPoint.left + (canvasCenterPoint.top - objectCenterPoint.y),
            top: canvasCenterPoint.top + (objectCenterPoint.x - canvasCenterPoint.left),
          })
          .setCoords();
      } else {
        obj.rotate(obj.angle - 90);

        const canvasCenterPoint = canvas.getCenter();
        const objectCenterPoint = obj.getCenterPoint();

        obj
          .set({
            left: canvasCenterPoint.left + (objectCenterPoint.y - canvasCenterPoint.top),
            top: canvasCenterPoint.top + (canvasCenterPoint.left - objectCenterPoint.x),
          })
          .setCoords();
      }
    }
  });
};
